import React from "react";
import { Link } from "react-router-dom";
import classes from "./Calculators.module.scss";

function Calculators() {
  return (
    <div className={classes.calculators}>
      <div className={classes.calculatorsCards}>
        <div className={classes.calculatorsCard}>
          <Link to='/intrinsicvaluecalculator'>
            <h3>Intrinsic Value Calculate</h3>
          </Link>
        </div>
        <div className={classes.calculatorsCard}>
          <h3>Rule 72 Calculate</h3>
        </div>
        <div className={classes.calculatorsCard}>
          <h3>Comming Soon</h3>
        </div>
      </div>
    </div>
  );
}

export default Calculators;
